import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Button } from 'reactstrap';
import { AlertTriangle, CheckCircle, ChevronLeft } from 'react-feather';
import { Row, Col, } from 'reactstrap';

/**
 * Renders the PageTitle
 */
interface rootProps {
    title: string,
    breadCrumbItems: any,
    rightContent?: any,
    goBack?: any,
}
const PageTitle = (props: rootProps) => {
    const { rightContent } = props
    const title = props.title || "";
    const items = props.breadCrumbItems || "";
    const goBack = props.goBack;
    return (
        <>
            <div className="page__breadcrumb d-flex align-items-center justify-content-between">
                <div className="left">
                    <h4 className="mb-0 mt-0 page__title">{title}</h4>
                    <Breadcrumb className="font-size-14 d-none d-sm-block">
                        <BreadcrumbItem>
                            <Link to="/"><i className='uil-home-alt'></i></Link>
                        </BreadcrumbItem>
                        {items.map((item: any, index: number) => {
                            return item.active ? (
                                <BreadcrumbItem active key={index}>
                                    {item.label}
                                </BreadcrumbItem>
                            ) : (
                                <BreadcrumbItem key={index}>
                                    <Link to={item.path}>{item.label}</Link>
                                </BreadcrumbItem>
                            );
                        })}
                    </Breadcrumb>
                </div>
                <div className="right__breadcrumb">
                    {rightContent}
                </div>
            </div>

        </>
    )
}

export default PageTitle;